import type { Target } from 'shared/types';

export const redirectTo = (url: string, target: Target = '_self') => {
  window.open(url, target);
};
